<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container-fluid">
        <section id="main-content">
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-title">
                  <h4>日曆</h4>
                  <div class="workdayCount">本月工作日: {{workDay}} 天</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- <div class="col-lg-3"> -->
                    <!-- <a href="#" data-toggle="modal" data-target="#add-category"
                        class="btn btn-lg btn-success btn-block waves-effect waves-light">
                        <i class="fa fa-plus"></i> 新增事項
                      </a>
                      <div id="external-events" class="m-t-20">                        
                        <div class="external-event bg-primary" data-class="bg-primary">
                          公告
                        </div>
                        <div class="external-event bg-pink" data-class="bg-pink">
                          請假
                        </div>
                        <div class="external-event bg-warning" data-class="bg-warning">
                          <i class="fa fa-move"></i>Meet manager
                        </div>
                        <div class="external-event bg-dark" data-class="bg-dark">
                          <i class="fa fa-move"></i>Create New theme
                        </div>
                    </div>-->

                    <!-- checkbox -->
                    <!-- <div class="checkbox m-t-40">
                        <input id="drop-remove" type="checkbox">
                        <label for="drop-remove">
                          Remove after drop
                        </label>
                    </div>-->

                    <!-- </div> -->
                    <div class="col-md-12">
                      <div class="card-box">
                        <FullCalendar
                          ref="fullCalendar"
                          defaultView="dayGridMonth"
                          :weekends="calendarWeekends"
                          :events="events"
                          :header="{
                            left: 'prev,next, today',
                            center: 'title',
                            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                          }"
                          :editable="true"
                          :selectable="true"
                          :droppable="true"
                          locale="zh-tw"
                          :buttonText="buttonText"
                          :plugins="calendarPlugins"
                          :datesRender="viewInit"
                          @select="setNewEventHandler"
                          @eventClick="changeEventHandler"
                          @eventDrop="dropEventHandler"
                        />
                      </div>
                    </div>
                    <!-- end col -->
                    <!-- BEGIN MODAL -->
                    <div class="modal fade none-border" id="event-modal" ref="eventmodal">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title">
                              <strong>訊息視窗</strong>
                            </h4>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-hidden="true"
                            >&times;</button>
                          </div>
                          <div class="modal-body">
                            <div v-if="modalObj.actionflag">
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label">開始時間</label>
                                    <input
                                      class="form-control"
                                      placeholder="輸入訊息內容"
                                      type="datetime-local"
                                      id="msgStartTime"
                                      name="msgStartTime"
                                      v-model="modalObj.inputs.startTime"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label">結束時間</label>
                                    <input
                                      class="form-control"
                                      placeholder="輸入訊息內容"
                                      type="datetime-local"
                                      id="msgEndTime"
                                      name="msgEndTime"
                                      v-model="modalObj.inputs.endTime"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label">訊息標題</label>
                                    <input
                                      class="form-control"
                                      placeholder="輸入訊息標題"
                                      type="text"
                                      id="msgTitle"
                                      name="title"
                                      v-model.trim="modalObj.inputs.msgTitle"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label">訊息內容</label>
                                    <input
                                      class="form-control"
                                      placeholder="輸入訊息內容"
                                      type="text"
                                      id="msgContent"
                                      name="title"
                                      v-model.trim="modalObj.inputs.msgTxt"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label">標籤</label>
                                    <select
                                      id="msgTag"
                                      class="form-control"
                                      name="category"
                                      v-model="modalObj.inputs.msgTag"
                                    >
                                      <option value disabled selected>選擇標籤</option>
                                      <option value="2">公告</option>
                                      <option value="1" v-if="modalObj.optionflag">請假</option>
                                      <option value="3" v-if="!modalObj.optionflag">加班</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-6" v-if="User.auth">
                                  <div class="form-group">
                                    <label class="control-label">選擇部門</label>
                                    <select
                                      class="form-control"
                                      v-if="depData"
                                      v-model="modalObj.inputs.dep"
                                    >
                                      <option value disabled selected>選擇部門</option>
                                      <option
                                        v-for="dep in depData"
                                        :key="dep.dep"
                                        :value="dep.dep"
                                      >{{dep.name}}</option>
                                      <option value="all" v-if="User.dep === 'all'">全部門</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div class="alert alert-secondary">
                                <p>標題：{{modalObj.inputs.msgTitle}}</p>
                                <p>內容：{{modalObj.inputs.msgTxt}}</p>
                                <p v-if="modalObj.inputs.msgUrl">
                                  附件:
                                  <a class="text-dark" :href="'msg/'+link" v-for="(link, i) in modalObj.inputs.msgUrl" :key="i" target="_blank">附件{{i+1}}</a>
                                </p>
                              </div>                              
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-secondary waves-effect"
                              data-dismiss="modal"
                            >取消</button>
                            <button
                              type="button"
                              class="btn btn-success save-event waves-effect waves-light"
                              v-if="modalObj.actionflag"
                              @click.prevent="setNewMsg"
                            >新增</button>
                            <button
                              type="button"
                              class="btn btn-danger delete-event waves-effect waves-light"
                              v-if="!modalObj.actionflag"
                              @click.prevent="deleteMsg"
                            >刪除</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Modal Add Category -->
                    <!-- <div class="modal fade none-border" id="add-category">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            <h4 class="modal-title">
                              <strong>Add a category </strong>
                            </h4>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="row">
                                <div class="col-md-6">
                                  <label class="control-label">Category Name</label>
                                  <input class="form-control form-white" placeholder="Enter name" type="text"
                                    name="category-name" />
                                </div>
                                <div class="col-md-6">
                                  <label class="control-label">Choose Category Color</label>
                                  <select class="form-control form-white" data-placeholder="Choose a color..."
                                    name="category-color">
                                    <option value="success">Success</option>
                                    <option value="danger">Danger</option>
                                    <option value="info">Info</option>
                                    <option value="pink">Pink</option>
                                    <option value="primary">Primary</option>
                                    <option value="warning">Warning</option>
                                  </select>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-default waves-effect"
                              data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-danger waves-effect waves-light save-category"
                              data-dismiss="modal">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>-->
                    <!-- END MODAL -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

export default {
  data() {
    return {
      calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      calendarWeekends: true,
      events: [],
      buttonText: {
        today: '今天',
        month: '月',
        week: '周',
        day: '天'
      },
      calendar: {
        start: '',
        end: ''
      },
      mainDep: '',
      calendar: {
        month: '',
        year: '',
        start: '',
        end: ''
      },
      modalObj: {
        actionflag: true, // 新增(true)還是刪除(false)
        optionflag: true, // 請假(true)還是加班(false)
        inputs: {
          id: '',
          startTime: '',
          endTime: '',
          msgTitle: '',
          msgTxt: '',
          msgTag: '',
          dep: '',
          msgUrl: ''
        }
      }
    };
  },
  props: {
    User: {
      type: Object,
      required: true
    },
    mainColorObj: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    depAry: {
      type: Array,
      required: true
    }
  },
  components: {
    FullCalendar
  },
  created() {
    this.mainDep = this.$route.params.dep;
  },
  mounted() {
    (async () => {
      await this.getCalendarData();
    })();

    $(this.$refs.eventmodal).on('hidden.bs.modal', this.eventModalHide);
  },
  computed: {
    depData() {
      if (this.depAry.length == 0) return [];
      return this.depAry.reduce((prev, next) => {
        if (next == this.mainDep) {
          let name = '海報';
          if (next == 'card') name = '名片';
          if (next == 'ink') name = '大圖';
          if (next == 'digit') name = '數位';
          prev.push(Object.assign({}, { dep: next, name: name }));
        }
        return prev;
      }, []);
    },
    workDay() {
      const mon = this.calendar.month;
      const year = this.calendar.year;
      let count = 0;
      let curDate = new Date(`${year}-${mon}`); //設定月份
      curDate.setMonth(mon); //下月
      curDate.setDate(0); // 本月最後一日
      const lastDate = curDate.getDate();
      curDate.setMonth(mon - 1); //本月
      for (let i = 1; i <= lastDate; i++) {
        curDate.setDate(i);
        if (curDate.getDay() !== 6 && curDate.getDay() !== 0) {
          count += 1;
        }
      }

      if(this.events.length>0){
        this.events.forEach(el=>{
          if(el.name === this.User.userName && el.typeCode === '1'){ 
            let sd = new Date(el.end).getTime() - new Date(el.start).getTime() ;         
            sd = Math.floor(sd / (60*60*1000))
            if(sd - 24 > 0 ){
              sd = Math.ceil(sd/24)
            }else{
              sd = 1;
            }
            console.log(sd)
            count -= sd;
          }
        })
      }
      return count;
    }
  },
  methods: {
    eventModalHide() {
      this.modalObj.inputs.msgTitle = '';
      this.modalObj.inputs.msgTxt = '';
      this.modalObj.inputs.dep = '';
      this.modalObj.inputs.id = '';
      this.modalObj.inputs.msgTag = '';
      this.modalObj.inputs.startTime = '';
      this.modalObj.inputs.endTime = '';
    },
    setNewEventHandler(el) {
      const startTime = el.start;
      const endTime = el.end;
      const startTimeDay = new Date(startTime).getDay();
      this.modalObj.actionflag = true;
      if (startTimeDay !== 6 && startTimeDay !== 0) {
        this.modalObj.optionflag = true;
      } else {
        this.modalObj.optionflag = false;
      }
      if (!this.User.auth) {
        this.modalObj.inputs.dep = this.User.dep;
      }

      this.modalObj.inputs.startTime = moment(startTime)
        .format()
        .split('+')[0];
      this.modalObj.inputs.endTime = moment(endTime)
        .format()
        .split('+')[0];
      $('#event-modal').modal('show');
    },
    changeEventHandler(el) {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: { function: 'getCalendarMsgOnModal', mid: el.event.id }
      }).done(res => {
        const data = JSON.parse(res);
        console.log(data);
        this.modalObj.inputs.msgTitle = data[0].title;
        this.modalObj.inputs.id = el.event.id;
        this.modalObj.inputs.msgTxt = data[0].content;
        this.modalObj.inputs.msgUrl = data[0].msgurl ? data[0].msgurl.split('||').slice(0, -1):'';
        this.modalObj.actionflag = false;
        $('#event-modal').modal('show');
      });
    },
    dropEventHandler(...args) {
      const m_id = args[0].event.id;
      let newStart = moment(args[0].event.start)
        .format()
        .split('+')[0];
      let newEnd = args[0].event.end
        ? moment(args[0].event.end)
            .format()
            .split('+')[0]
        : newStart;
      let oldStart = moment(args[0].oldEvent.start)
        .format()
        .split('+')[0];
      let oldEnd = args[0].oldEvent.end
        ? moment(args[0].event.end)
            .format()
            .split('+')[0]
        : oldStart;

      newStart = timeFilter(newStart);
      newEnd = timeFilter(newEnd);
      oldStart = timeFilter(oldStart);
      oldEnd = timeFilter(oldEnd);

      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'updateDateFromCalendar',
          m_id,
          gh_id: this.User.userId,
          newTime: `${newStart}@${newEnd}`
        }
      }).done(res => {
        if (res !== '1') {
          this.$bus.$emit('message:push', '無法修改此訊息', 'danger');
          this.events = [];
          this.getCalendarData();
        }
      });
    },
    viewInit(...args) {
      let currentStart = new Date(args[0].view.currentStart).getTime();
      let currentEnd = new Date(args[0].view.currentEnd).getTime();
      this.calendar.start = formatDate(currentStart);
      this.calendar.end = formatDate(currentEnd);
      this.calendar.month = new Date(args[0].view.currentStart).getMonth() + 1;
      this.calendar.year = new Date(args[0].view.currentStart).getFullYear();
    },
    getCalendarData() {
      let period = `${this.calendar.start}@${this.calendar.end}`;
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'showMsgToCalendar',
          dep: this.mainDep,
          period: period
        }
      }).done(res => {
        const data = JSON.parse(res);
        let ary = data.reduce((prev, next) => {
          let obj = Object.assign(
            {},
            {
              id: next.m_id,
              title: `${next.name}-${next.title}`,
              start: next.startdate,
              end: next.enddate,
              allDay: next.startdate == next.enddate ? true : false,
              typeCode:next.typecode,
              name:next.name,
              className:
                next.typecode == '2'
                  ? 'bg-primary border-primary text-light'
                  : next.typecode == '1'
                  ? 'bg-warning border-warning text-dark'
                  : 'bg-info border-info text-light'
            }
          );
          prev.push(obj);
          return prev;
        }, []);
        this.events = ary;
      });
    },
    setNewMsg() {
      let title = this.modalObj.inputs.msgTitle;
      let content = this.modalObj.inputs.msgTxt;
      let dep = this.modalObj.inputs.dep;
      let tag = this.modalObj.inputs.msgTag;
      let startDate = this.modalObj.inputs.startTime;
      let endDate = this.modalObj.inputs.endTime;
      let editDate = timeFilter(
        moment()
          .format()
          .split('+')[0]
      );
      let gh_id = this.User.userId;
      if (!title || !tag || !dep || !content) return;
      if (!startDate || !endDate) return;
      console.log(editDate);
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'SaveMsgFromCalendar',
          data: JSON.stringify({
            title,
            content,
            tag,
            dep,
            startDate,
            endDate,
            editDate,
            gh_id
          })
        }
      }).done(res => {
        if (res) {
          this.getCalendarData();
          $('#event-modal').modal('hide');
        }
      });
    },
    deleteMsg() {
      if (confirm('確定刪除？')) {
        $.ajax({
          url: './php/main.php',
          type: 'post',
          data: {
            function: 'deleteMsgFromCalendar',
            data: JSON.stringify({
              m_id: this.modalObj.inputs.id,
              gh_id: this.User.userId
            })
          }
        }).done(res => {
          const data = JSON.parse(res);
          if (res === '1') {
            this.getCalendarData();
          } else {
            this.$bus.$emit('message:push', '無法刪除此訊息', 'danger');
          }
          $('#event-modal').modal('hide');
        });
      }
    }
  }
};

function formatDate(time) {
  let curDate = new Date(time);
  let date = `${curDate.getFullYear()}-${String(
    curDate.getMonth() + 1
  ).padStart(2, '0')}-${String(curDate.getDate()).padStart(2, '0')}`;
  return date;
}

function timeFilter(time = []) {
  time = time.split('');
  if (time.indexOf('T') === -1) return false;
  time.splice(time.indexOf('T'), 1, ' ');
  time = time.join('');
  return time;
}
</script>

<style>
.self-wrap {
  margin-left: 15px;
}
.workdayCount {
  /* display: inline-block; */
  float: right;
}
.fc-unthemed td.fc-today {
  background: #fcf8e3 !important;
}
</style>